import type { SVGProps } from 'react';
import { forwardRef } from 'react';

const LogicalOrIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  function LogicalOrIcon(props, ref) {
    return (
      <svg
        ref={ref}
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <mask
          id="mask0_231_9200"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="17"
          height="16"
        >
          <rect x="0.5" width="16" height="16" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_231_9200)">
          <path
            d="M8.49997 11.9434C7.77107 12.4518 6.88459 12.75 5.92847 12.75C3.44319 12.75 1.42847 10.7353 1.42847 8.25C1.42847 5.76472 3.44319 3.75 5.92847 3.75C6.88459 3.75 7.77107 4.04819 8.49997 4.55664C9.22888 4.04819 10.1154 3.75 11.0715 3.75C13.5568 3.75 15.5715 5.76472 15.5715 8.25C15.5715 10.7353 13.5568 12.75 11.0715 12.75C10.1154 12.75 9.22888 12.4518 8.49997 11.9434Z"
            fill="#1F1F22"
          />
        </g>
      </svg>
    );
  },
);

export default LogicalOrIcon;
